import { useCallback, useMemo, useRef } from "react";

export function useSingleFlight() {
    const running = useRef(false);
    const isRunning = useCallback(() => running.current, []);
    const run = useCallback(async <T>(operation: () => Promise<T>) => {
        if (running.current) return undefined;
        running.current = true;
        try {
            return await operation();
        } finally {
            running.current = false;
        }
    }, []);

    return useMemo(() => ({ isRunning, run }), [isRunning, run]);
}
